module.exports = __webpack_public_path__ + "static/media/mapa-a10.d604fcab.png";